/** Schreibberechtigung – spiegelt api/core/permissions.py WRITE_GUEST_PITCH_BOOKING */

import { ADMIN_GROUPS, isOfficeMember, normGroups } from "@/lib/acl";

const WRITE_GUEST_PITCH_BOOKING = ["Camping-Admin", "Camping-Rezeption"] as const;
const WRITE_INVOICE_PAYMENT = ["Camping-Admin", "Camping-Rezeption", "Camping-Buchhaltung"] as const;
const WRITE_STAMMDATEN = ["Camping-Admin"] as const;

export function canWriteGuestPitchBooking(userGroups: string[] = []): boolean {
  const g = normGroups(userGroups);
  if (g.some((x) => ADMIN_GROUPS.includes(x))) return true;
  return g.some((x) => (WRITE_GUEST_PITCH_BOOKING as readonly string[]).includes(x));
}

/** Rechnungen ausstellen / Zahlungen – spiegelt api/core/permissions.py WRITE_INVOICE_PAYMENT */
export function canWriteInvoice(userGroups: string[] = []): boolean {
  const g = normGroups(userGroups);
  if (g.some((x) => ADMIN_GROUPS.includes(x))) return true;
  if (isOfficeMember(g)) return true;
  return g.some((x) => (WRITE_INVOICE_PAYMENT as readonly string[]).includes(x));
}

/** Buchhaltungs-Einstellungen, Konten, Briefkopf – Camping-Admin oder Gruppe Büro. */
export function canWriteAccountingSettings(userGroups: string[] = []): boolean {
  return canWriteStammdaten(userGroups) || isOfficeMember(userGroups);
}

/** Rechnungsstorno – nur Admin (spiegelt api/core/permissions.py ADMIN_ONLY) */
export function canCancelInvoice(userGroups: string[] = []): boolean {
  const g = normGroups(userGroups);
  if (g.some((x) => ADMIN_GROUPS.includes(x))) return true;
  return g.some((x) => (WRITE_STAMMDATEN as readonly string[]).includes(x));
}

/** Gruppe Camping-Admin – darf Tickets bearbeiten. Legacy: App-Admins / App-Admin / Admins. */
export function isAppAdmin(userGroups: string[] = []): boolean {
  return normGroups(userGroups).some((group) => {
    const compact = group.toLocaleLowerCase("de").replace(/[\s_-]+/g, "");
    return (
      compact === "campingadmin" ||
      compact === "appadmins" ||
      compact === "appadmin" ||
      compact === "admins"
    );
  });
}

/** Öffentliche Website: Texte, Fotos und Kacheln. Admin und Rezeption. */
export function canWriteWebsiteContent(userGroups: string[] = []): boolean {
  return canWriteGuestPitchBooking(userGroups);
}

/** Kategorien, Artikel, Preise, Buchungszuordnung – spiegelt api/core/permissions.py ADMIN_ONLY */
export function canWriteStammdaten(userGroups: string[] = []): boolean {
  const g = normGroups(userGroups);
  if (g.some((x) => ADMIN_GROUPS.includes(x))) return true;
  return g.some((x) => (WRITE_STAMMDATEN as readonly string[]).includes(x));
}
